import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=21d346ca&scoped=true"
import script from "./Recycle.vue?vue&type=script&lang=js"
export * from "./Recycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d346ca",
  null
  
)

export default component.exports